// Shared GLTFLoader factory. All GLBs in /public/models are now compressed
// with EXT_meshopt_compression (gltf-transform optimize --compress meshopt),
// so every loader instance must have MeshoptDecoder wired before .load() —
// otherwise three throws "Unknown extension EXT_meshopt_compression".

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';

export function createGLTFLoader(): GLTFLoader {
  return new GLTFLoader().setMeshoptDecoder(MeshoptDecoder);
}
